import deepEqual from "fast-deep-equal";

const objectDiff = (
  a: { [k: string]: unknown },
  b: { [k: string]: unknown },
): { [k: string]: unknown } => {
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  const result: { [k: string]: unknown } = {};

  for (const bKey of bKeys) {
    if (aKeys.includes(bKey)) {
      if (deepEqual(a[bKey], b[bKey])) continue;
      result[bKey] = b[bKey];
    } else {
      result[bKey] = b[bKey];
    }
  }

  for (const aKey of aKeys) {
    if (!bKeys.includes(aKey)) {
      result[aKey] = null;
    }
  }

  return result;
};

export default objectDiff;
